<script setup>
import SupplierOrderGrid from '@/components/order/SupplierOrderGrid.vue'
</script>
<template>
  <supplier-order-grid />
</template>
